function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.8043 5.52763C9.86633 5.46575 9.91555 5.39224 9.94913 5.31131C9.98271 5.23038 10 5.14362 10 5.056C10 4.96838 9.98271 4.88162 9.94913 4.80069C9.91555 4.71976 9.86633 4.64625 9.8043 4.58437L5.37578 0.155848C5.32647 0.106445 5.26791 0.0672499 5.20344 0.0405075C5.13898 0.0137651 5.06987 -2.15503e-07 5.00007 -2.18554e-07C4.93028 -2.21605e-07 4.86117 0.0137651 4.7967 0.0405075C4.73223 0.0672499 4.67367 0.106444 4.62437 0.155848L0.195844 4.58437C-0.065284 4.8455 -0.065284 5.2665 0.195844 5.52763C0.456973 5.78875 0.877975 5.78875 1.1391 5.52763L5.00274 1.66932L8.86637 5.53295C9.12216 5.78875 9.5485 5.78875 9.8043 5.52763Z",
  fill: "#FA634D"
});
function SvgIconArrowUpLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowUpLine);
export default __webpack_public_path__ + "static/media/iconArrowUpLine.4184657d.svg";
export { ForwardRef as ReactComponent };